import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { OpcionCheckeable } from '../../../infrastructure/services/selects.service';
import * as _ from 'lodash';
import { SxTranslationService } from 'app/infrastructure/services/translation-service.service';

@Component({
  selector: 'sx-selector-multiple',
  templateUrl: 'selectorMultiple.component.html',
  styleUrls: ['selectorMultiple.css'],
})
export class SelectorMultipleComponent implements OnInit {
  @Input() titulo: string;
  @Input() listado: OpcionCheckeable[] = [];
  @Input() required: boolean=false;
  listadoSinFiltro : OpcionCheckeable[];
  searchAtt: string = '';
  @Output() editado: EventEmitter<Array<OpcionCheckeable>> = new EventEmitter();

  editando = false;

  listadoBackUp = [];

  constructor(private sxTranslationService: SxTranslationService) { }

  ngOnInit() {
  }

  iniciarEdicion() {
    // Backup del listado original por si cancela la edicion
    this.listadoBackUp = _.cloneDeep(this.listado);
    this.editando = true;
  }

  confirmarEdicion() {
    const retorno = [];
    this.listado.forEach(opcion => {
      if (opcion) {
        if (opcion.seleccionado) {
          retorno.push(opcion);
        }
      }
    });
   
    this.editado.emit(retorno);
    this.listadoBackUp = null;
    this.editando = false;
  }

  cancelarEdicion() {
    this.listado = _.cloneDeep(this.listadoBackUp);
    this.listadoBackUp = null;
    this.editando = false;
  }

  filterListado() {
    if (this.listadoSinFiltro == undefined)
      this.listadoSinFiltro = this.listado;

    this.listado = this.listadoSinFiltro.filter(
      item =>
        item.descripcion.toUpperCase().indexOf(this.searchAtt.toUpperCase()) !==
        -1
    );
    if (this.searchAtt == "") 
      this.listado = this.listadoSinFiltro;
  }

  searchTitle(){
    if(this.editando)
      return this.sxTranslationService.getResource('BUSCAR');
    else
      return this.sxTranslationService.getResource('');
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/helpers/components/selectorMultiple/selectorMultiple.component.ts